// Deterministic, rule-based crisis "vangnet" for the intake free-text.
// Intentionally conservative: clear suicidal-ideation / self-harm phrases only,
// to minimise false positives. Runs client-side so the safety notice is instant
// and the sensitive text never has to leave the device to be screened.
const PHRASES: string[] = [
  // NL
  "zelfmoord", "zelfdoding", "suïcide", "suicide", "een einde maken", "er een einde aan",
  "niet meer leven", "niet meer verder", "dood willen", "wil dood", "mezelf iets aandoen",
  "mezelf pijn doen", "geen zin meer om te leven", "het niet meer zien zitten",
  // FR
  "me suicider", "suicider", "en finir avec la vie", "en finir avec tout", "plus envie de vivre",
  "me faire du mal", "envie de mourir", "veux mourir",
  // EN
  "kill myself", "killing myself", "end my life", "want to die", "wanna die",
  "hurt myself", "harm myself", "self-harm", "self harm", "don't want to live", "no reason to live",
];

export function detectCrisis(text: string | undefined | null): boolean {
  if (!text) return false;
  const t = text.toLowerCase();
  return PHRASES.some((p) => t.includes(p));
}
